<div class="owner-name" *ngIf="installationDetailsStore.owner$ | async as owner">
  {{ owner?.name | dash }}
</div>
